(function($) {

    $.fn.menu = function() {

        var init = function() {
            var body = $('body'),
                siteHead = $('.js-site-head'),
                siteNav = $('.js-site-nav'),
                navToggle = $('.js-nav-toggle');

            navToggle.on('click', function () {
                body.toggleClass('is-no-scroll');
                siteHead.toggleClass('is-menu-open');
                siteNav.toggleClass('is-open');
                navToggle.toggleClass('is-open');
            });
        };

        init();
        return this;
    };

}($));
